import React from 'react';

import AvGroup from './AvGroup';
import Input from './Input';
import {AvFeedback, AvInput} from "availity-mobx-reactstrap-validation";
import userCountry from "js/services/UserCountry";
import Title from "js/components/pages/BuyerSignupPage/FullName/NameEntry/Title";

export default props => (
  <>
    <AvGroup>
      <Input {...props} />
    </AvGroup>

  </>

);
